import React from "react";
import { Container, Icon, Header, Button, Grid } from "semantic-ui-react";
import { Link } from "react-router-dom";

const PagarPrestamosPagoExitoso = () => {
  return (
    <Container style={{ width: "65%" }} textAlign="center">
      <br />
      <br />
      <Icon name="check circle outline" color="yellow" size="huge" />
      <Header as="h1" color="blue" size="huge">
        Gracias por su pago
      </Header>
      <Header as="h4" color="blue" size="tiny">
        Te enviamos un correo con el detalle de tu pago
      </Header>
      <br />
      <br />
      <br />
      <Grid stackable>
        <Grid.Row>
          <Grid.Column computer={8} largeScreen={8} mobile={8} tablet={8}>
            <Button
              as={Link}
              to="/inicio"
              // onClick={() => cleanRegister()}
              color="blue"
              fluid
              size="large"
              content="Ir al inicio"
            />
          </Grid.Column>
          <Grid.Column
            computer={8}
            largeScreen={8}
            mobile={8}
            tablet={8}
            textAlign="right"
          >
            <Button
              onClick={() => {
                window.location = "/pagar-prestamos";
              }}
              fluid
              color="yellow"
              size="large"
              content="Hacer otro pago"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Container></Container>
    </Container>
  );
};

export default PagarPrestamosPagoExitoso;
